import { toSanityLocale } from "@sourceful/shared-utils/sanity-utils";
import { i18n } from "../../next-i18next.config";

export const getDataBySanityLocale = <T extends unknown>(
  locale: string,
  data: Record<string, T>
) => {
  return data[toSanityLocale(locale || i18n.defaultLocale)];
};
